export default defineNuxtRouteMiddleware((to) => {
  const user = useUserStore()
  const isUserRoute = to.name.startsWith('user')

  //
  // Navigated unauthed users to log in view
  //
  if (isUserRoute && !user.authed) {
    return navigateTo({
      name: 'auth-log-in',
      query: {
        returnUrl: useFullPath(to.fullPath),
        ...to.query,
      }
    })
  }
})
